import { useState, useEffect } from "react";
import Config from "../../Config";


import InputDate from "../../helpers/InputDate";
import InputTime from "../../helpers/InputTime";
import InputText from "../../helpers/InputText";
import InputSearchKid from "../../helpers/InputSearchKid";
import InputCombo from "../../helpers/InputCombo";
import InputDateMulti from "../../helpers/InputDateMulti";



function InOutNew(props)
{

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

    
    const [view, setView] = useState('btn');

    const [errTab, setErrTab] = useState([]);  //z info od serwera..
    const [row, setRow] = useState({
        dzien:  "",
        dni:  "",
        godzina: "",
        operacja: "I",
        fraza: '',
        p_dziecko_id: '',
        powod: "",     
    });



    const valChangeListener = (filedName, val, correct, msg) => {

        console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);     
        setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );         
    }  

    const goNextNew = () => {
        console.log("goNext");
        saveData();
    }

    const valChecker = (fields) => {

        var allValid = true;

              
        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }


    const kidSelected = (p_dziecko_id) => {

 

        setRow( {...row, ['p_dziecko_id']:p_dziecko_id  } );
    }



    const saveData = () => {


 
        if(!valChecker(row))
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
            return;
        }

    


        if(row.p_dziecko_id == undefined || row.p_dziecko_id =='' || row.p_dziecko_id < 1)
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong ,  "Nie wybrano dziecka" ,  "ok"  ,null); 
            return; 
        }
        
 
        props.mainView.setProgress(-2);

        var req =  row;


        fetch( Config.url + '/rest_v1_kids,inout_add', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    changeView();

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       props.mainView.showDialog( "Sukces",  "Pozycja została dodana" , "ok" , null);    
                       props.onSuccess();                      
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;

    }



    const changeView = () => {

    setRow({
        dzien:  "",
        godzina: "",
        fraza: '',
        operacja: "I",
        p_dziecko_id: '',
        powod: "",  
    });
        
        if(view == 'btn') {setView("dlg"); }  else setView('btn');
    }     



    if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setView('btn');
        }


    var opType = [
        {
            v:"I",
            title: 'Wejście'
        },
        {
            v:"O",
            title: 'Wyjście'
        },        
    ];
 


    var dlg_view =  (

            <div className="dlg_window dlg_type_x shadowx">

                    <div className="dlg_title">
                        Nowa godzina wejścia lub wyjścia
                    </div>


                    <div className="dlg_content_x">


                                    <div className="form_tab">

                                        <div className="form_control">
                                            <div className="fieldName">Dziecko</div>
                                            <InputSearchKid archiwalne='0'  mainView={props.mainView} userData={props.userData}   err={errTab} kidSelected={kidSelected} valChange={valChangeListener} goNext={goNextNew} name="fraza" placeholder={"Dziecko: "} className=' w250 ' req='1' firstUp="1" />
                                        </div>

                                        <br/>

                                        <div className="form_control">
                                            <div className="fieldName">Typ</div>
                                            <InputCombo  items={opType} mainView={props.mainView} userData={props.userData}  value={row.operacja}  err={errTab}   valChange={valChangeListener} goNext={goNextNew} name="operacja" placeholder={"Typ: "} className='  ' req='1' firstUp="1" />
                                        </div>


                                        <div className="form_control">
                                            <div className="fieldName">Dzień</div>
                                            <InputDateMulti   userData={props.userData} value={row.dzien} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="dzien" placeholder={"Dzień: "} className=' w150 ' req='1' firstUp="1" />
                                        </div>

                                        <div className="form_control">
                                            <div className="fieldName">Godzina</div>
                                            <InputTime   userData={props.userData} value={row.godzina} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="godzina" placeholder={"Godzina: "} className=' w150 ' req='1' firstUp="1" />
                                        </div>
                                        

                                        <div className="form_split"></div>

                                        <div className="form_control">
                                            <div className="fieldName">Opis*</div>
                                            <InputText   userData={props.userData} value={row.powod} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="powod" placeholder={"Opis: np. Korekta godziny "} className=' w300 ' req='1' firstUp="1" />
                                        </div>

                                        <div className="form_split"></div>

                                        <div className="form_control">                                            
                                            <div className="btn" onClick={saveData}>dodaj</div>
                                            &nbsp; &nbsp;
                                            <div className="btn" onClick={changeView}>anuluj</div>
                                        </div>

                                        <br/>&nbsp;
                                        </div>

                    </div>

                
            </div>
    );

    if(view == 'btn') dlg_view = null;

    var defLink = "btn";
    if(props.className != undefined) defLink = props.className;

    return  <div className="inline_block">
                <div className={defLink}    onClick={changeView} >dodaj wejście lub wyjście </div> 
                {dlg_view} 
           </div>
}


export default InOutNew;